import type { i18n } from '@wix/fe-essentials/i18n';
import { useFormPreview, type FormValues } from '@wix/form-viewer/widget';
import { Text } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';

interface FormPreviewProps {
  formId: string;
  formValues: FormValues;
  i18n: i18n;
}

export const FormPreview = ({ formId, formValues, i18n }: FormPreviewProps) => {
  const formattedValues = useFormPreview(formId, formValues, i18n);

  if (!formattedValues) {
    return <div>Placeholder for fallback</div>;
  }

  return (
    <ul data-hook="form-preview">
      {formattedValues.map(({ label, value }) => {
        if (typeof value === 'string') {
          return (
            <li data-hook="form-preview-item">
              <Text>
                {label} - {value}
              </Text>
            </li>
          );
        }
        if (typeof value === 'number') {
          return (
            <li data-hook="form-preview-item">
              <Text>
                {label} - {value}
              </Text>
            </li>
          );
        }
        if (typeof value === 'boolean') {
          return (
            <li data-hook="form-preview-item">
              <Text>{label}</Text>
            </li>
          );
        }
        if (Array.isArray(value)) {
          return (
            <div data-hook="form-preview-item">
              <Text>{label}:</Text>
              <ul>
                {value.map((item) => {
                  if (typeof item === 'string') {
                    return (
                      <li>
                        <Text>{item}</Text>
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            </div>
          );
        }
        return null;
      })}
    </ul>
  );
};
